<h1 style="color: #2A6ECF;">{{ isAdminContext ? 'Gestão de Prédio' : 'PRÉDIOS' }}</h1>

<form [formGroup]="reservationForm" (ngSubmit)="onSubmit()">
  <div class="fields">
    <div class="column">
      <tds-datetime
        id="datetime"
        type="date"
        min="{{ today() }}"
        max="{{ todayPlus14() }}"
        size="lg"
        label="Data"
        label-position="outside"
        tds-aria-label="A datetime component"
        formControlName="date"
      ></tds-datetime>
    </div>

    <!-- <div class="column">
      <tds-dropdown
        name="dropdown"
        label="Período"
        label-position="outside"
        animation="slide"
        open-direction="auto"
        tds-aria-label="A dropdown component"
        formControlName="period"
      >
        <tds-dropdown-option value="3">Integral</tds-dropdown-option>
        <tds-dropdown-option value="1">Manhã</tds-dropdown-option>
        <tds-dropdown-option value="2">Tarde</tds-dropdown-option>
      </tds-dropdown>
    </div> -->

    <div class="column">
      <tds-dropdown
        name="dropdown"
        label="Prédio"
        label-position="outside"
        animation="slide"
        open-direction="auto"
        tds-aria-label="A dropdown component"
        formControlName="building"
      >
        @for (building of buildingData(); track `${building.id}_${$index}`) {
          <tds-dropdown-option [value]="building.id">
            P{{ building.building }}-{{ building.region }}
          </tds-dropdown-option>
        }
      </tds-dropdown>
    </div>
  </div>

  <br>
  <br>
</form>

@if (bookingReqData()) {
  <br>

  @if (messageData() && messageData()!.content) {
    <app-message [message]="messageData()"></app-message>
  }

  <br>

  <router-outlet></router-outlet>
}